import { CommentOutlined } from "@mui/icons-material";
import { DownloadForOffline } from "@mui/icons-material";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  AlertTitle,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Paper,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { TYPE_NOTIFICATION } from "../../../components/reusable/NotificationBull";
import useToast from "../../../hooks/useToast";
import {
  evaluation_refonte_fiche_evaluation_service,
  evaluation_refonte_reponse_service,
} from "../../../services/PersonalEvaluationRefonteService";
import UserService from "../../../services/UserService";
import DialogChoixFicheEvaluation from "../fiche_evaluation/DialogChoixFicheEvaluation";
import CommentaireConsultantEditForm from "./CommentaireConsultantEditForm";
import EvaluationExaminationForm from "./EvaluationExaminationForm";
import EvaluationExaminationFormResume from "./EvaluationExaminationFormResume";

const EvaluationForm = () => {
  const [current_user, setCurrentUser] = useState(null);
  const [open_form, setOpenForm] = useState(false);
  const [openDialogueExportFiche, setOpenDialogueExportFiche] = useState(false);
  const bonjour = new Date().getHours() < 19 ? "Bonjour " : "Bonsoir ";
  const [texte_salutaion, setTextSalutation] = useState(bonjour);
  const [formResumeOpen, setFormResumeOpen] = useState(false);
  const [question_response_by_user, setQuestionReponseByUser] = useState([]);
  const [interviewCommentState, setInterviewCommentState] = useState(null);
  const [interviewCommentStatus, setInterviewCommentStatus] = useState("idle");
  const { showToast, Toast } = useToast();
  const loadInterviewCommentStateRef = useRef(null);
  const refreshCurrentUserRef = useRef(null);
  const [openCommentaireDialog, setOpenCommentaireDialog] = useState(false);
  const [openLoadingSimpleBackdrop, setopenLoadingSimpleBackdrop] =
    useState(false);

  const loadInterviewCommentState = async (signal) => {
    setInterviewCommentStatus("loading");
    try {
      const state =
        await evaluation_refonte_reponse_service.getInterviewCommentState(
          signal,
        );
      if (signal?.aborted) return;
      setInterviewCommentState(state);
      setInterviewCommentStatus("success");
    } catch (error) {
      if (signal?.aborted) return;
      setInterviewCommentState(null);
      setInterviewCommentStatus("error");
      showToast(
        TYPE_NOTIFICATION.ERROR,
        error.message || "Impossible de charger l’état du commentaire.",
      );
    }
  };

  const refreshCurentUser = () => {
    setopenLoadingSimpleBackdrop(true);
    UserService.myCompleteUserInfoForEvaluation().then((res) => {
      if (res && res.data) {
        setCurrentUser(res.data);
        if (res?.data?.length === 0) {
          showToast(TYPE_NOTIFICATION.ERROR, "Aucune information trouvée");
        }
        checkIfEvaluationAlreadyDone(res.data.user_id);

        setTextSalutation(
          `${bonjour} ${res.data.last_name || ""} ${res.data.first_name || ""}`,
        );
      } else {
        setopenLoadingSimpleBackdrop(false);
      }
    });
  };

  const checkIfEvaluationAlreadyDone = (candidat_id) => {
    evaluation_refonte_fiche_evaluation_service
      .getAllDetailByUserId(candidat_id)
      .then((res) => {
        if (res) {
          setQuestionReponseByUser(res.data);
        }
      })
      .catch((error) => {
        showToast(
          TYPE_NOTIFICATION.ERROR,
          error?.message || "Impossible de charger l'évaluation",
        );
      })
      .finally(() => {
        setopenLoadingSimpleBackdrop(false);
      });
  };

  loadInterviewCommentStateRef.current = loadInterviewCommentState;
  refreshCurrentUserRef.current = refreshCurentUser;

  const onCloseForm = () => {
    setOpenForm(false);
    refreshCurentUser();
    loadInterviewCommentState();
  };

  const handleCLickStartEvaluation = () => {
    setOpenForm(true);
  };

  const handleCloseFormResumeDIalog = () => {
    onCloseForm();
    setFormResumeOpen(false);
  };

  const handleFormCommentaireOpen = () => {
    setOpenCommentaireDialog(true);
  };

  const handleFormCommentaireClose = (wasSaved = false) => {
    setOpenCommentaireDialog(false);
    if (wasSaved) {
      loadInterviewCommentState();
    }
  };

  const handleDialogChoixFicheEvaluationOpen = () => {
    setOpenDialogueExportFiche(true);
  };

  const handleCloserExportFiche = () => {
    setOpenDialogueExportFiche(false);
  };

  useEffect(() => {
    const controller = new AbortController();
    loadInterviewCommentStateRef.current(controller.signal);
    refreshCurrentUserRef.current();
    return () => controller.abort();
  }, []);

  const isFinalEvaluationCompleted = Boolean(
    interviewCommentState?.isFinalEvaluationCompleted,
  );
  const isInterviewCommentLoading = interviewCommentStatus === "loading";
  const hasInterviewCommentError = interviewCommentStatus === "error";

  return (
    <>
      <Toast />
      <DialogChoixFicheEvaluation
        open={openDialogueExportFiche}
        onClose={handleCloserExportFiche}
        idCandidat={current_user?.user_id}
      />
      <CommentaireConsultantEditForm
        open={openCommentaireDialog}
        userId={current_user?.user_id}
        onFormClose={handleFormCommentaireClose}
      />
      <EvaluationExaminationFormResume
        selected_employee={current_user}
        isOpen={formResumeOpen}
        handleClose={handleCloseFormResumeDIalog}
      />
      {/*  <LoadingSimpleBackdrop
        openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
      /> */}
      <EvaluationExaminationForm
        candidat={current_user}
        isOpen={open_form}
        handleClose={onCloseForm}
      />
      {openLoadingSimpleBackdrop && (
        <Grid textAlign={"center"}>
          <CircularProgress color="primary" />
        </Grid>
      )}
      {!openLoadingSimpleBackdrop && (
        <Paper sx={{ borderTop: "2px solid #00a452" }}>
          {question_response_by_user.length > 0 ? (
            <Grid>
              <CardHeader
                title={
                  <>
                    <div>
                      {texte_salutaion}, <br />
                      {question_response_by_user.some(
                        (item) => item.TERMINEE === "1",
                      )
                        ? "Vous avez déjà fais votre auto-evaluation, vous pouvez à tous moment modifier vos reponse sauf si vous avez terminé et envoyé les données enregistrées."
                        : "La première phase de l'evaluation du personnel est votre auto-évaluation. Vous allez juste glisser le slider par rapport au note que vous estimez sur la question posée."}
                    </div>
                    <Grid container spacing={2} justifyContent="center">
                      <Grid item mt={3}>
                        <Alert
                          severity={
                            hasInterviewCommentError ||
                            isFinalEvaluationCompleted
                              ? "info"
                              : "success"
                          }
                          variant="outlined"
                          sx={{ borderLeft: "2px solid #4f52f7" }}
                        >
                          <AlertTitle>Indication</AlertTitle>
                          {hasInterviewCommentError
                            ? "Impossible de vérifier si le commentaire est encore modifiable. Rechargez la page."
                            : isFinalEvaluationCompleted
                              ? "Le circuit d’évaluation est terminé. Le commentaire ne peut plus être modifié."
                              : "Vous pouvez modifier le commentaire sur l’entrevue jusqu’à la clôture de l’évaluation par le dernier supérieur."}
                        </Alert>
                      </Grid>
                    </Grid>
                  </>
                }
                titleTypographyProps={{
                  variant: "h6",
                  /* color: 'primary', */
                  gutterBottom: true,
                }}
              />
              <CardContent>
                <Grid container spacing={1} justifyContent={"center"}>
                  <Grid item>
                    <LoadingButton
                      variant="contained"
                      color="primary"
                      disabled={!current_user}
                      startIcon={<PsychologyAltOutlinedIcon />}
                      onClick={handleCLickStartEvaluation}
                    >
                      {question_response_by_user.some(
                        (item) => item.TERMINEE === "1",
                      )
                        ? "Afficher evaluation"
                        : "Commencer"}
                    </LoadingButton>
                  </Grid>
                  {question_response_by_user.some(
                    (item) => item.TERMINEE === "1",
                  ) && (
                    <>
                      <Grid item>
                        <LoadingButton
                          variant="outlined"
                          onClick={handleFormCommentaireOpen}
                          startIcon={<CommentOutlined />}
                          disabled={
                            isInterviewCommentLoading ||
                            hasInterviewCommentError ||
                            isFinalEvaluationCompleted
                          }
                          loading={isInterviewCommentLoading}
                          title={
                            isFinalEvaluationCompleted
                              ? "Le dernier supérieur a terminé l’évaluation."
                              : "Modifier commentaire"
                          }
                        >
                          Modifier commentaire
                        </LoadingButton>
                      </Grid>
                      <Grid item>
                        <LoadingButton
                          variant="outlined"
                          onClick={handleDialogChoixFicheEvaluationOpen}
                          startIcon={<DownloadForOffline />}
                        >
                          Telecharger fiche
                        </LoadingButton>
                      </Grid>
                    </>
                  )}
                  {/* <LoadingButton
                  sx={{ ml: 1, display: "none" }}
                  variant="outlined"
                  color="secondary"
                  disabled={!current_user}
                  startIcon={<RemoveRedEyeOutlined />}
                  onClick={handleShowEvaluationResume}
                >
                  Afficher resumé
                </LoadingButton> */}
                </Grid>
              </CardContent>
            </Grid>
          ) : (
            <Grid>
              <Alert severity="error">
                <AlertTitle>Questionnaire non trouvé</AlertTitle>
                Aucune question disponible pour vous evaluer (raison : aucune
                session ou fiche d'evaluation active ). <br />
                Veuillez contacter le responsable de l'evaluation du personnel
              </Alert>
            </Grid>
          )}
        </Paper>
      )}
    </>
  );
};

export default EvaluationForm;
